import { TextField } from '@material-ui/core'

export default function FieldsText({
  classes,
  field,
  handleInput,
  formSelected
}) {
  return(
    <div className={classes.body__fields_text}>
      <TextField
        variant='outlined'
        label={field.summary_title}
        onChange={evt => handleInput(field.field_id, evt.target.value)}
        required={formSelected.mandatory}
        className={classes.body__fields_textItem}
      />
    </div>
  )
}